import { render, staticRenderFns } from "./FuturesList.vue?vue&type=template&id=160e1792&scoped=true"
import script from "./FuturesList.vue?vue&type=script&lang=js"
export * from "./FuturesList.vue?vue&type=script&lang=js"
import style0 from "./FuturesList.vue?vue&type=style&index=0&id=160e1792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e1792",
  null
  
)

export default component.exports